module.exports = "https://cdn.hellotech.com/client-assets/mobile-mobile_d4f6bbb2e8ad2a0920f9e12043d04798.jpg";